import styled, { css } from 'styled-components';

export const StyledMenu = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: #FFF;
  border: 1px solid var(--light-blue);
  border-radius: .45rem;
  transform: ${({ open }) => open ? 'translateX(2%)' : 'translateX(-104%)'};
  height: 21rem;
  width: 200px;
  text-align: left;
  padding: 2rem;
  position: absolute;
  top: .5rem;
  left: 2%;
  transition: transform 0.3s ease-in-out;
  img {
    position: absolute;
    top: .25rem;
    left: 2.5rem;
    height: 2.5rem;
  }

  .active {
    color: var(--light-green);
    font-weight: bold;
  }
  .links-div {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
  }

  a {
    text-decoration: none;
    color: var(--gray-800);
    padding: 2rem;
    padding-right: 0;
    margin-left: -2rem;
    width: calc(100% + 4rem);
    font-size: 1.2rem;
  }
`;

export const StyledBurger = styled.button`
  position: absolute;
  left: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background-color: transparent;
  width: 2rem;
  height: 2rem;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;

  div {
    width: 2rem;
    height: 0.25rem;
    background: ${({ open }) => open ? '#0D0C1D' : '#636363'};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    :first-child {
      transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
    }

    :nth-child(2) {
      opacity: ${({ open }) => open ? '0' : '1'};
      transform: ${({ open }) => open ? 'translateX(20px)' : 'translateX(0)'};
    }

    :nth-child(3) {
      transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }
`